export type PanelCause = {
  cause: string;
  probability: number;
};

export type PanelFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: PanelCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  PanelCause[],
  string[],
  string,
  string
];

const C = (
  cause: string,
  probability: number,
): PanelCause => ({
  cause,
  probability,
});

const rows: Row[] = [
[
  "panel-001",
  "القاطع الرئيسي",
  "القاطع الرئيسي يفصل فوراً من أرفعه",
  "من تحاول تشغل القاطع الرئيسي يرجع يفصل مباشرة.",
  "القاطع الرئيسي ما يبقى شغال",
  [C("أكو شورت قوي داخل اللوحة أو بأحد الخطوط الخارجة", 50), C("أكو تسريب إلى الأرضي", 30), C("القاطع نفسه متضرر", 20)],
  ["خلي القاطع مفصول وحدد الخط المسبب.", "افحص القاطع والخطوط الخارجة بواسطة فني مؤهل."],
  "حرجة",
  "قاطع رئيسي يفصل فوراً main breaker trip short",
],
[
  "panel-002",
  "القاطع الرئيسي",
  "القاطع الرئيسي يفصل بعد فترة",
  "اللوحة تشتغل بالبداية وبعد فترة القاطع الرئيسي يفصل.",
  "الفصل يصير بعد تشغيل لفترة",
  [C("الحمل أعلى من تحمل القاطع", 50), C("أكو ربط مرخي يسبب حرارة", 30), C("القاطع ضعيف أو متقادم", 20)],
  ["راجع مجموع الأحمال.", "افحص الربطات والقاطع ومقطع الكيبل."],
  "عالية",
  "قاطع رئيسي يفصل بعد فترة overload thermal trip",
],
[
  "panel-003",
  "القاطع الرئيسي",
  "حرارة القاطع الرئيسي ترتفع",
  "حرارة جسم القاطع أو أطرافه ترتفع بشكل مو طبيعي.",
  "ارتفاع حرارة القاطع الرئيسي",
  [C("ربط الأطراف مرخي", 50), C("الحمل قريب من حد القاطع", 30), C("تلف داخلي بالقاطع", 20)],
  ["خفف الحمل وخلي اللوحة تحت المراقبة.", "إذا الحرارة قوية افصل التغذية وخلي فني يفحصه."],
  "حرجة",
  "حرارة القاطع الرئيسي breaker overheating",
],
[
  "panel-004",
  "القاطع الرئيسي",
  "القاطع الرئيسي ما يقبل يثبت",
  "القاطع يرجع لوضع الفصل وما يثبت على التشغيل.",
  "القاطع الرئيسي ما يثبت",
  [C("أكو عطل مستمر بأحد المخارج", 45), C("آلية القاطع متضررة", 30), C("أكو تسريب أو شورت", 25)],
  ["افصل القواطع الفرعية وحاول تحديد الدائرة المسببة.", "إذا ما يثبت حتى بدون مخارج، يحتاج فحص أو تبديل."],
  "عالية",
  "main breaker will not reset",
],
[
  "panel-005",
  "القواطع الفرعية",
  "قاطع فرعي يفصل فوراً",
  "قاطع واحد داخل اللوحة يفصل مباشرة من تشغله.",
  "القاطع الفرعي يفصل فوراً",
  [C("شورت بالدائرة الخارجة", 55), C("جهاز مربوط على الخط بيه عطل", 25), C("القاطع نفسه متضرر", 20)],
  ["افصل الحمل عن الخط.", "افحص الدائرة والحمل قبل إعادة التشغيل."],
  "عالية",
  "MCB branch breaker immediate trip",
],
[
  "panel-006",
  "القواطع الفرعية",
  "قاطع فرعي يفصل بعد كم دقيقة",
  "الدائرة تشتغل فترة وبعدها القاطع الفرعي يفصل.",
  "الفصل يصير بعد مدة",
  [C("الحمل زايد على الخط", 55), C("ربط مرخي يسبب حرارة", 25), C("القاطع تعبان", 20)],
  ["قلل الحمل على الدائرة.", "افحص أطراف القاطع ومقطع السلك."],
  "عالية",
  "MCB thermal trip overload",
],
[
  "panel-007",
  "القواطع الفرعية",
  "قاطع يفصل من يشتغل حمل معين",
  "القاطع يبقى طبيعي لحد ما يشتغل جهاز أو حمل محدد.",
  "الفصل مرتبط بحمل معين",
  [C("الحمل نفسه بيه شورت أو تسريب", 55), C("تيار البدء عالي", 25), C("الدائرة أصغر من الحمل", 20)],
  ["افصل الحمل المشتبه وجرب الدائرة بدونه.", "افحص الحمل والدائرة قبل إرجاعه."],
  "عالية",
  "breaker trips specific load",
],
[
  "panel-008",
  "القواطع الفرعية",
  "قاطع يفصل حتى بدون حمل واضح",
  "القاطع يفصل رغم ماكو حمل واضح شغال على الدائرة.",
  "فصل بدون سبب ظاهر",
  [C("تلف بالعزل داخل التمديد", 45), C("رطوبة أو تسريب أرضي", 30), C("القاطع نفسه خربان", 25)],
  ["خلي الدائرة مفصولة.", "افحص العزل والقاطع بواسطة فني مؤهل."],
  "حرجة",
  "breaker trips no load insulation fault",
],
[
  "panel-009",
  "قاطع التسريب RCCB",
  "قاطع التسريب يفصل كل شوي",
  "RCCB يفصل بصورة متكررة حتى لو القواطع الفرعية تبين طبيعية.",
  "فصل متكرر لقاطع التسريب",
  [C("أكو تسريب أرضي بأحد الخطوط", 50), C("النيوترال (البارد) لامس الأرضي", 30), C("RCCB نفسه متضرر", 20)],
  ["افصل الدوائر الفرعية وحدة وحدة حتى تعرف المسبب.", "لا تلغي قاطع التسريب حتى لو يسبب فصل."],
  "حرجة",
  "RCCB RCD repeated trip earth leakage",
],
[
  "panel-010",
  "قاطع التسريب RCCB",
  "قاطع التسريب يفصل ويا دائرة معينة",
  "RCCB يفصل من تشغل قاطع فرعي أو خط محدد.",
  "التسريب مرتبط بدائرة معينة",
  [C("تسريب بالأجهزة أو التمديد", 55), C("رطوبة داخل الدائرة", 25), C("خلط بالنيوترال (البارد) بين دائرتين", 20)],
  ["خلي الدائرة المسببة مفصولة.", "افحص عزلها والنيوترال (البارد) والأرضي."],
  "حرجة",
  "RCD trip specific circuit",
],
[
  "panel-011",
  "قاطع التسريب RCCB",
  "قاطع التسريب ما يقبل يثبت",
  "RCCB ما يبقى على وضع التشغيل.",
  "RCCB ما يثبت",
  [C("تسريب مستمر", 55), C("تلامس النيوترال (البارد) ويا الأرضي", 25), C("القاطع متضرر", 20)],
  ["افصل القواطع الفرعية قبل المحاولة.", "إذا بعده ما يثبت يحتاج فحص فني."],
  "حرجة",
  "RCCB will not reset",
],
[
  "panel-012",
  "قاطع التسريب RCCB",
  "زر TEST مال قاطع التسريب ما يشتغل",
  "تضغط زر TEST وما يصير فصل.",
  "زر الاختبار ما يفصل",
  [C("آلية الاختبار داخل القاطع متضررة", 70), C("توصيل القاطع مو صحيح", 30)],
  ["لا تعتمد على القاطع إذا زر TEST ما يشتغل.", "خلي فني يفحصه أو يبدله."],
  "حرجة",
  "RCCB RCD TEST button not working",
],
[
  "panel-013",
  "بارات الفاز",
  "حرارة بار الفاز ترتفع",
  "حرارة البار النحاسي أو نقاط الربط ترتفع بشكل واضح.",
  "ارتفاع حرارة بار الفاز",
  [C("براغي الربط مرخية", 50), C("الحمل عالي على البار", 30), C("أكو أكسدة أو تلامس ضعيف", 20)],
  ["افصل التغذية وخلي الربطات تنفحص.", "افحص آثار تغير اللون أو الاحتراق."],
  "حرجة",
  "busbar phase overheating hot busbar",
],
[
  "panel-014",
  "بار النيوترال (البارد)",
  "حرارة بار النيوترال (البارد) ترتفع",
  "حرارة بار النيوترال (البارد) أو نقاطه ترتفع أكثر من الطبيعي.",
  "ارتفاع حرارة بار البارد",
  [C("ربطات النيوترال (البارد) مرخية", 50), C("تيار النيوترال (البارد) عالي", 30), C("تلامس أو أكسدة بالبار", 20)],
  ["افصل التغذية وخلي نقاط الربط تنفحص.", "افحص الأحمال وتوازنها إذا النظام متعدد الفازات."],
  "حرجة",
  "neutral bar overheating البارد",
],
[
  "panel-015",
  "بار الأرضي",
  "ربط بار الأرضي مرخي",
  "أسلاك الأرضي مو مثبتة مضبوط أو أكو نقطة ربط رخوة.",
  "أرضي اللوحة مو ثابت",
  [C("برغي الربط مرخي", 60), C("تآكل أو أكسدة", 25), C("سلك الأرضي مقطوع جزئياً", 15)],
  ["خلي الربط يتصلح بعد فصل التغذية.", "تأكد من استمرارية التأريض بواسطة فني مؤهل."],
  "حرجة",
  "earth bar loose grounding panel",
],
[
  "panel-016",
  "الأطراف الرئيسية",
  "حرارة نقطة الربط الرئيسية ترتفع",
  "حرارة اللگ أو نقطة دخول الكيبل الرئيسي ترتفع.",
  "ارتفاع حرارة نقطة الدخول",
  [C("الربط مرخي", 55), C("اللگ مو مناسب لمقطع الكيبل", 25), C("أكسدة أو تلامس ضعيف", 20)],
  ["افصل التغذية قبل لمس نقطة الدخول.", "بدل اللگ أو صحح الربط إذا متضرر."],
  "حرجة",
  "main lug overheating loose terminal",
],
[
  "panel-017",
  "الترمنلات",
  "حرارة الترمنل ترتفع",
  "حرارة بلوك التوصيل أو الترمنل ترتفع مع الحمل.",
  "ترمنل حار",
  [C("برغي الترمنل مرخي", 55), C("الحمل أعلى من تحمله", 25), C("الترمنل متضرر", 20)],
  ["افصل التغذية وخلي الربط يتصلح.", "بدل الترمنل إذا بيه ذوبان أو تغير لون."],
  "عالية",
  "terminal block overheating",
],
[
  "panel-018",
  "الترمنلات",
  "برغي ترمنل مرخي",
  "السلك يتحرك داخل الترمنل أو الربط مو ثابت.",
  "ربط السلك مو ثابت",
  [C("الربط ما متشد مضبوط", 60), C("اهتزاز داخل اللوحة", 25), C("الترمنل متشقق أو متضرر", 15)],
  ["افصل التغذية قبل إعادة الربط.", "بدل الترمنل إذا ما يثبت السلك."],
  "عالية",
  "loose terminal screw panel",
],
[
  "panel-019",
  "الأسلاك الداخلية",
  "عازل سلك داخل اللوحة متضرر",
  "أكو تشقق أو ذوبان أو جرح بعازل أحد الأسلاك.",
  "عازل السلك متضرر",
  [C("حرارة عالية", 40), C("احتكاك بحافة حادة", 30), C("تقادم أو حمل زائد", 30)],
  ["افصل التغذية واستبدل الجزء المتضرر.", "عالج سبب الحرارة أو الاحتكاك."],
  "حرجة",
  "damaged insulation panel wiring",
],
[
  "panel-020",
  "مداخل الكيبلات",
  "مدخل الكيبل مو مثبت مضبوط",
  "الكيبل داخل اللوحة بدون تثبيت كافي أو العازل قريب من حافة حادة.",
  "الكيبل يتحرك بمدخل اللوحة",
  [C("Cable gland مرخي أو مفقود", 55), C("فتحة الدخول مو محمية", 25), C("شد ميكانيكي على الكيبل", 20)],
  ["ثبت الكيبل بگلاند مناسب.", "احمِ العازل من الحواف الحادة."],
  "عالية",
  "cable gland loose panel",
],
[
  "panel-021",
  "اللوحة الكهربائية",
  "أكو ريحة حرك من اللوحة",
  "تطلع ريحة بلاستك أو عازل محترق من داخل اللوحة.",
  "ريحة حرك داخل اللوحة",
  [C("وصلة ترتفع حرارتها", 45), C("قاطع أو كونتاكتور متضرر", 30), C("عازل سلك يحترك", 25)],
  ["افصل التغذية إذا الريحة قوية.", "حدد مصدر الحرارة قبل إعادة التشغيل."],
  "حرجة",
  "burning smell electrical panel",
],
[
  "panel-022",
  "اللوحة الكهربائية",
  "أكو شرر داخل اللوحة",
  "تشوف شرر أو قوس كهربائي بين نقاط أو أجزاء داخل اللوحة.",
  "شرر أو وميض داخل اللوحة",
  [C("ربط مرخي جداً", 45), C("عزل متضرر", 30), C("جزء كهربائي متشقق أو متفحم", 25)],
  ["ابتعد عن اللوحة وافصل التغذية من نقطة آمنة إذا ممكن.", "لا تفتحها أو تشتغل عليها وهي حية."],
  "حرجة",
  "sparking arcing electrical panel",
],
[
  "panel-023",
  "اللوحة الكهربائية",
  "أكو طنين قوي من اللوحة",
  "ينسمع طنين أعلى من الطبيعي من داخل اللوحة.",
  "صوت طنين مستمر",
  [C("كونتاكتور يطن", 40), C("ربط أو قطعة تهتز", 30), C("محولة سيطرة أو ملف بيه مشكلة", 30)],
  ["حدد مصدر الصوت بعد عزل التغذية.", "افحص الكونتاكتور والمحولة والربطات."],
  "عالية",
  "buzzing electrical panel",
],
[
  "panel-024",
  "التغذية ثلاثية الفاز",
  "فاز واحد مفقود",
  "أحد الفازات مو موجود واللوحة تبقى على فازين أو أقل.",
  "فقدان فاز",
  [C("فيوز فاز محترق", 40), C("قاطع أو نقطة ربط متضررة", 35), C("انقطاع من المصدر", 25)],
  ["وقف الأحمال ثلاثية الفاز.", "افحص الفيوزات والتغذية بواسطة فني مؤهل."],
  "حرجة",
  "phase loss single phasing panel",
],
[
  "panel-025",
  "التغذية ثلاثية الفاز",
  "الفازات مو متوازنة",
  "الفولت أو التيار يختلف بشكل واضح بين الفازات.",
  "عدم توازن الفازات",
  [C("الأحمال موزعة بشكل مو متساوي", 50), C("وصلة بأحد الفازات ضعيفة", 30), C("مشكلة من المصدر", 20)],
  ["راجع توزيع الأحمال.", "افحص التيارات والفولتات بواسطة فني مؤهل."],
  "عالية",
  "phase imbalance electrical panel",
],
[
  "panel-026",
  "التغذية ثلاثية الفاز",
  "ترتيب الفازات غلط",
  "المحركات تدور بالعكس أو ريليه تسلسل الفازات يمنع التشغيل.",
  "تسلسل الفازات مو صحيح",
  [C("تم تبديل فازين بالتغذية", 70), C("ريليه تسلسل الفازات مضبوط غلط", 30)],
  ["لا تبدل الفازات واللوحة حية.", "خلي فني يصحح التسلسل بعد العزل."],
  "عالية",
  "phase sequence reversed",
],
[
  "panel-027",
  "التغذية",
  "الفولت عالي داخل اللوحة",
  "قراءة الفولت أعلى من الطبيعي على أحد الخطوط أو كلها.",
  "ارتفاع الفولت",
  [C("المصدر جاي بفولت عالي", 55), C("مشكلة بالنيوترال (البارد)", 30), C("جهاز تنظيم أو قياس متضرر", 15)],
  ["افصل الأحمال الحساسة.", "خلي فني يفحص المصدر والنيوترال (البارد)."],
  "حرجة",
  "panel overvoltage high voltage",
],
[
  "panel-028",
  "التغذية",
  "الفولت واطي داخل اللوحة",
  "قراءة الفولت أقل من المطلوب وتظهر مشاكل تشغيل بالأحمال.",
  "انخفاض الفولت",
  [C("هبوط من المصدر", 45), C("وصلة رئيسية ضعيفة", 35), C("حمل عالي", 20)],
  ["خفف الأحمال مؤقتاً.", "افحص المصدر والربطات ومقطع الكيبل."],
  "عالية",
  "panel undervoltage low voltage",
],
[
  "panel-029",
  "التغذية",
  "الفولت يصعد وينزل داخل اللوحة",
  "قراءة الفولت مو ثابتة وتتغير بشكل واضح.",
  "تذبذب بالفولت",
  [C("المصدر مو مستقر", 40), C("ربط رئيسي مرخي", 35), C("النيوترال (البارد) ضعيف", 25)],
  ["افصل الأحمال الحساسة إذا التذبذب قوي.", "خلي فني يفحص المصدر والربطات."],
  "حرجة",
  "voltage fluctuation panel",
],
[
  "panel-030",
  "النيوترال (البارد)",
  "النيوترال (البارد) مقطوع",
  "مسار النيوترال (البارد) مفتوح أو ما يوصل للأحمال.",
  "فقدان البارد",
  [C("سلك النيوترال (البارد) مقطوع", 50), C("ربط محترق", 30), C("بار النيوترال (البارد) متضرر", 20)],
  ["افصل الأحمال الحساسة.", "خلي فني يفحص مسار النيوترال (البارد) فوراً."],
  "حرجة",
  "open neutral panel البارد",
],
[
  "panel-031",
  "النيوترال (البارد)",
  "ربط النيوترال (البارد) مرخي",
  "أكو نقطة ربط رخوة بمسار النيوترال (البارد).",
  "تغير فولت أو حرارة بنقطة البارد",
  [C("برغي الربط مرخي", 60), C("أكسدة بالنقطة", 25), C("اللگ متضرر", 15)],
  ["افصل التغذية قبل إعادة الربط.", "افحص أي آثار حرارة أو احتراق."],
  "حرجة",
  "loose neutral panel",
],
[
  "panel-032",
  "التأريض",
  "تأريض اللوحة ضعيف أو مقطوع",
  "مسار الأرضي مو مستمر أو ربط جسم اللوحة بالأرضي مو مضمون.",
  "مشكلة بتأريض اللوحة",
  [C("سلك الأرضي مفصول", 50), C("ربط الأرضي مرخي", 30), C("تآكل بنقطة الربط", 20)],
  ["لا تشغل اللوحة بدون تأريض سليم.", "خلي فني يفحص استمرارية الأرضي."],
  "حرجة",
  "panel grounding earth fault",
],
[
  "panel-033",
  "الفيوزات",
  "فيوز محترق",
  "أحد الفيوزات مفتوح وما يمرر التغذية.",
  "فيوز فاصل",
  [C("شورت بالدائرة", 45), C("حمل زائد", 35), C("الفيوز غير مناسب", 20)],
  ["لا تبدل الفيوز قبل معرفة السبب.", "استخدم نفس النوع والتصنيف الصحيح بعد الإصلاح."],
  "عالية",
  "blown fuse electrical panel",
],
[
  "panel-034",
  "الفيوزات",
  "الفيوز يحترك كل مرة",
  "الفيوز الجديد يرجع يفصل أو يحترك بسرعة.",
  "تكرار احتراق الفيوز",
  [C("شورت مستمر", 50), C("الحمل أعلى من التصنيف", 30), C("اختيار فيوز مو صحيح", 20)],
  ["خلي الدائرة مفصولة.", "حدد سبب التيار العالي قبل تبديل الفيوز مرة ثانية."],
  "حرجة",
  "fuse blows repeatedly",
],
[
  "panel-035",
  "حامل الفيوز",
  "حرارة حامل الفيوز ترتفع",
  "حرارة قاعدة الفيوز أو أطرافها ترتفع بشكل واضح.",
  "ارتفاع حرارة حامل الفيوز",
  [C("تلامس ضعيف", 50), C("ربط مرخي", 30), C("حامل الفيوز متضرر", 20)],
  ["افصل التغذية.", "بدل حامل الفيوز إذا بيه تغير لون أو ذوبان."],
  "عالية",
  "fuse holder overheating",
],
[
  "panel-036",
  "حماية زيادة الجهد SPD",
  "حماية الـ SPD تبين متضررة",
  "مؤشر حماية الصواعق أو زيادة الجهد يبين حالة عطل أو فقدان حماية.",
  "مؤشر SPD مو طبيعي",
  [C("SPD استهلك بعد نبضة جهد", 55), C("توصيل أو حماية احتياطية بيها مشكلة", 25), C("المؤشر نفسه متضرر", 20)],
  ["اتبع مؤشر الشركة المصنعة.", "خلي فني يفحص أو يبدل الـ SPD إذا انتهت الحماية."],
  "عالية",
  "SPD surge protector failed panel",
],
[
  "panel-037",
  "الكونتاكتور",
  "الكونتاكتور ما يسحب",
  "ملف الكونتاكتور ما يجذب والكونتاكتور يبقى مفتوح.",
  "الكونتاكتور ما يشتغل",
  [C("ماكو فولت على الملف", 45), C("ملف الكونتاكتور محترق", 35), C("ميكانيكية الكونتاكتور عالقة", 20)],
  ["افحص دائرة السيطرة أولاً.", "إذا الفولت واصل والملف ما يشتغل، افحص الكونتاكتور."],
  "عالية",
  "contactor not pulling in coil",
],
[
  "panel-038",
  "الكونتاكتور",
  "الكونتاكتور يطن",
  "صوت طنين قوي يطلع من الكونتاكتور وهو شغال.",
  "طنين بالكونتاكتور",
  [C("فولت الملف واطي", 45), C("سطح القلب الحديدي متسخ أو متضرر", 30), C("الملف أو الكونتاكتور متعب", 25)],
  ["افحص فولت ملف الكونتاكتور.", "نظف أو بدل الكونتاكتور إذا استمر الطنين."],
  "متوسطة",
  "contactor buzzing",
],
[
  "panel-039",
  "الكونتاكتور",
  "الكونتاكتور يفصل ويرجع بسرعة",
  "الكونتاكتور يسحب ويفصل بصورة متكررة.",
  "تقطيع بالكونتاكتور",
  [C("فولت السيطرة مو ثابت", 45), C("كونتاكت مساعد أو دائرة مسك بيها مشكلة", 35), C("ملف الكونتاكتور ضعيف", 20)],
  ["افحص دائرة المسك وفولت السيطرة.", "لا تخلي الحمل يشتغل بالتقطيع حتى ما يتضرر."],
  "عالية",
  "contactor chattering",
],
[
  "panel-040",
  "الكونتاكتور",
  "نقاط الكونتاكتور محترقة",
  "الكونتاكتات الرئيسية بيها حرك أو تآكل واضح.",
  "تلف بنقاط الكونتاكتور",
  [C("فصل وتشغيل متكرر تحت حمل عالي", 40), C("الحمل أعلى من تحمل الكونتاكتور", 35), C("ربط ضعيف أو قوس كهربائي", 25)],
  ["بدل الكونتاكتور أو نقاطه إذا قابلة للتبديل.", "تأكد من اختيار الكونتاكتور المناسب للحمل."],
  "عالية",
  "burnt contactor contacts",
],
[
  "panel-041",
  "الأوفرلود",
  "الأوفرلود يفصل باستمرار",
  "ريليه الأوفرلود يفصل الحمل كل شوي.",
  "فصل متكرر للأوفرلود",
  [C("الحمل يسحب تيار عالي", 50), C("إعداد الأوفرلود أقل من تيار الحمل الصحيح", 30), C("فقدان فاز أو عدم توازن", 20)],
  ["لا ترفع الإعداد عشوائياً.", "افحص تيار الحمل والفازات وإعداد الأوفرلود."],
  "عالية",
  "overload relay trips repeatedly",
],
[
  "panel-042",
  "الأوفرلود",
  "الأوفرلود ما يقبل Reset",
  "بعد الفصل، الأوفرلود ما يرجع لوضع التشغيل.",
  "الأوفرلود ما يرجع",
  [C("بعده حار ويحتاج وقت يبرد", 40), C("آلية Reset متضررة", 35), C("العطل بالحمل بعده موجود", 25)],
  ["خلي الحمل مفصول.", "افحص سبب الفصل قبل إعادة التشغيل."],
  "عالية",
  "overload relay will not reset",
],
[
  "panel-043",
  "الأوفرلود",
  "الأوفرلود ما يحمي الحمل بشكل صحيح",
  "الحمل يسحب تيار غير طبيعي والحماية ما تفصل مثل المطلوب.",
  "الحماية مو متناسبة ويا الحمل",
  [C("إعداد الأوفرلود أعلى من المطلوب", 50), C("اختيار أوفرلود غير مناسب", 30), C("الريليه متضرر", 20)],
  ["راجع إعداد الحماية حسب تيار الحمل الاسمي.", "بدل الأوفرلود إذا ما يستجيب بشكل صحيح."],
  "حرجة",
  "overload relay not tripping setting",
],
[
  "panel-044",
  "ريليه مراقبة الفازات",
  "ريليه الفازات يمنع التشغيل",
  "ريليه مراقبة الفاز يعطي عطل وما يسمح للحمل يشتغل.",
  "إشارة خطأ بريليه الفازات",
  [C("فاز مفقود", 40), C("ترتيب الفازات غلط", 30), C("الفولت خارج الحدود", 20), C("الريليه متضرر", 10)],
  ["افحص وجود الفازات وترتيبها.", "افحص إعدادات الريليه قبل تبديله."],
  "عالية",
  "phase monitoring relay fault",
],
[
  "panel-045",
  "محولة السيطرة",
  "محولة السيطرة ما تطلع فولت",
  "أكو فولت على دخل المحولة لكن ماكو خرج طبيعي لدائرة السيطرة.",
  "دائرة السيطرة بدون فولت",
  [C("فيوز المحولة محترق", 40), C("ملف المحولة متضرر", 35), C("توصيل الدخل أو الخرج بيه قطع", 25)],
  ["افصل التغذية وافحص فيوزات المحولة.", "إذا الدخل موجود والخرج مفقود، تحتاج فحص المحولة."],
  "عالية",
  "control transformer no output",
],
[
  "panel-046",
  "دائرة السيطرة",
  "دائرة السيطرة ما بيها فولت",
  "أجزاء القدرة موجودة بس أزرار وريليات السيطرة ما تشتغل.",
  "ماكو فولت سيطرة",
  [C("فيوز السيطرة فاصل", 40), C("محولة أو مزود السيطرة متضرر", 35), C("سلك أو ترمنل مقطوع", 25)],
  ["افحص مصدر فولت السيطرة.", "افحص الفيوز والترمنلات بعد فصل التغذية."],
  "عالية",
  "control circuit no voltage",
],
[
  "panel-047",
  "أزرار السيطرة",
  "زر التشغيل ما يشتغل",
  "تضغط زر التشغيل وما يصير أمر تشغيل.",
  "Start ما يشتغل",
  [C("نقاط الزر متضررة", 45), C("سلك مفصول", 30), C("سلسلة الحماية مفتوحة", 25)],
  ["افحص الزر ودائرة السيطرة.", "تأكد من شروط الحماية قبل تجاوز أي نقطة."],
  "متوسطة",
  "start push button not working",
],
[
  "panel-048",
  "أزرار السيطرة",
  "زر الإيقاف ما يشتغل بشكل صحيح",
  "زر الإيقاف ما يفصل الأمر مثل المطلوب.",
  "Stop ما يوقف",
  [C("نقاط زر الإيقاف عالقة", 50), C("توصيل الزر غلط", 30), C("دائرة السيطرة بيها تجاوز غير صحيح", 20)],
  ["وقف اللوحة من قاطع آمن إذا زر الإيقاف ما يشتغل.", "خلي فني يصلح دائرة الإيقاف قبل إعادة التشغيل."],
  "حرجة",
  "stop push button not working",
],
[
  "panel-049",
  "ATS التحويل التلقائي",
  "الـ ATS ما يحول للمصدر الثاني",
  "من ينقطع المصدر الأول، اللوحة ما تنتقل للمصدر الاحتياطي.",
  "التحويل التلقائي ما يصير",
  [C("إشارة المصدر الاحتياطي مو موجودة", 35), C("دائرة السيطرة أو ريليه التحويل بيه عطل", 35), C("كونتاكتور أو موتور ATS متضرر", 30)],
  ["تأكد من توفر المصدر الاحتياطي.", "افحص دائرة السيطرة وآلية التحويل بواسطة فني مؤهل."],
  "حرجة",
  "ATS automatic transfer switch not transfer",
],
[
  "panel-050",
  "تهوية ونظافة اللوحة",
  "حرارة اللوحة الداخلية ترتفع",
  "داخل اللوحة يصير حار زيادة أو المروحة والفلتر ما يشتغلن مضبوط.",
  "حرارة عالية داخل اللوحة",
  [C("مروحة التهوية متوقفة", 40), C("الفلتر مسدود بالغبار", 30), C("اللوحة محملة زيادة أو التهوية قليلة", 30)],
  ["نظف الفلاتر وخلي مسارات التهوية مفتوحة.", "افحص مروحة اللوحة والحمل ودرجة الحرارة."],
  "عالية",
  "panel internal temperature fan filter overheating",
],
];

export const panelFaults: PanelFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method:
            "افصل التغذية قبل فتح اللوحة أو لمس الربطات. أي قياس على أجزاء حية أو داخل اللوحة يكون بواسطة فني كهربائي مؤهل وبمعدات مناسبة.",
          normal:
            "ماكو آثار حرك أو حرارة عالية أو شرر، والربطات ثابتة والجزء يشتغل بصورة طبيعية.",
          faulty:
            "وجود حرارة عالية أو اسوداد أو شرر أو فصل متكرر أو ربط مرخي يدل على عطل يحتاج إصلاح.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: أكو احتمال صعقة أو حريق أو قوس كهربائي. افصل التغذية من نقطة آمنة ولا تلمس أجزاء مكشوفة.",
            "العمل أو القياس على لوحة حية خليه لفني كهربائي مؤهل.",
          ]
        : [
            "افصل التغذية قبل الفك أو إعادة الربط.",
            "إذا شفت شرر أو ذوبان أو اسوداد أو شميت ريحة حرك، لا ترجع تشغل اللوحة قبل الإصلاح.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
